module.exports = __webpack_public_path__ + "img/WEISS.cc2dad30.svg";